// extracted by mini-css-extract-plugin
export default {"link":"vFqvoK","root":"IZK7jh","label":"Y4yGtj"};